import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasMediaExported.meta';

export type UseTrackCanvasMediaExportedParams = {
  canvas_id: string;
  number_of_media: number;
  destination: 'desktop' | 'workspace';
  board_id?: string;
  scope?: 'selection' | 'all';
};

export const useTrackCanvasMediaExported = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasMediaExported = useCallback(
    (params: UseTrackCanvasMediaExportedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasMediaExported };
};
